import { request } from './utils/http';

const noop = _ => _;

export default class CommonImportPlugin {
  constructor(options) {
    this.settings = { ...options
    };
  }

  install(ctx) {
    const self = this;
    const {
      settings
    } = self;
    const {
      beforeImport = noop,
      afterImport = noop,
      beforeRownum = noop,
      afterRownum = noop
    } = settings; // 获取导入行数

    ctx.plugin('rownum', async (vm, params, cb) => {
      const {
        rownumUrl,
        rownumParams = {},
        rownumHeaders = {}
      } = settings;
      const requestConfig = {
        url: rownumUrl,
        body: { ...rownumParams,
          fileToken: params.fileToken
        },
        headers: { ...rownumHeaders,
          'Content-Type': rownumHeaders.contentType || 'application/x-www-form-urlencoded'
        }
      };

      try {
        const res = await request(beforeRownum(requestConfig));
        cb(afterRownum(res));
      } catch (e) {
        console.error(e.message);
        cb(null);
      }
    }); // 执行导入

    ctx.plugin('import', async (vm, params, cb) => {
      const {
        importUrl,
        importParams = {},
        importHeaders = {}
      } = settings;
      const requestConfig = {
        url: importUrl,
        body: { ...importParams,
          fileToken: params.fileToken
        },
        headers: { ...importHeaders,
          'Content-Type': importHeaders.contentType || 'application/x-www-form-urlencoded'
        }
      };

      try {
        const res = await request(beforeImport(requestConfig));
        cb(afterImport(res));
      } catch (e) {
        console.error(e.message);
        cb(null);
      }
    });
  }

}